import { getCookie } from '@/utils/cookie';

type AgeVerificationType = 'simple' | 'advanced';

interface AgeVerification {
    type: AgeVerificationType;
    required: boolean;
    isGuest: boolean;
}

export const getAVCookie = (): AgeVerification | null => {
    const av = getCookie('av');
    if (!av) {
        return null;
    }

    const [type, required, isGuest] = av.split(':');

    return {
        type: type as AgeVerificationType,
        required: required === 'True',
        isGuest: isGuest === 'True',
    };
};

export const isAgeVerificationRequired = (): boolean => {
    const av = getAVCookie();

    if (!av) {
        return true;
    }

    const agePass = getCookie('age_pass');

    return !((av.type === 'simple' && agePass === '1') || (av.type === 'advanced' && !av.required));
};

export const isSimpleAvRequired = (): boolean => {
    const av = getAVCookie();

    if (!av) {
        return false;
    }

    return av.type === 'simple' && av.required;
};

export const isAdvancedAvType = (): boolean => {
    const av = getAVCookie();

    if (!av) {
        return false;
    }

    return av.type === 'advanced';
};
